import axios from "axios";

const normalizeBase = (value) => {
  const raw = String(value || "").trim();
  if (!raw) return "";
  return raw.endsWith("/") ? raw : `${raw}/`;
};

const DEFAULT_BASE = "https://hmam.prootech-cloud.com/api/";
const API_BASE = normalizeBase(process.env.REACT_APP_API_URL || DEFAULT_BASE);

const getApiCandidates = () => {
  const list = [API_BASE, DEFAULT_BASE, "http://127.0.0.1:5000/api/"];
  if (typeof window !== "undefined" && window.location?.hostname) {
    list.push(`${window.location.origin}/api/`);
    list.push(`${window.location.protocol}//${window.location.hostname}:5000/api/`);
  }
  return [...new Set(list.map(normalizeBase).filter(Boolean))].map(
    (base) => `${base}package-time-blocks`
  );
};

const requestWithFallback = async (factory) => {
  let lastError = null;
  const candidates = getApiCandidates();

  for (const endpoint of candidates) {
    try {
      return await factory(endpoint);
    } catch (error) {
      lastError = error;
    }
  }

  throw lastError || new Error("Package time blocks API unavailable");
};

export const getPackageTimeBlocksApi = async (date) => {
  const query = date ? `?date=${encodeURIComponent(date)}` : "";
  const response = await requestWithFallback((endpoint) =>
    axios.get(`${endpoint}${query}`)
  );
  return response.data;
};

export const addPackageTimeBlockApi = async ({
  packageId,
  date,
  startTime,
  endTime,
  reason,
}) => {
  const response = await requestWithFallback((endpoint) =>
    axios.post(`${endpoint}/add`, {
      packageId,
      date,
      startTime,
      endTime,
      reason,
    })
  );
  return response.data;
};

export const removePackageTimeBlockApi = async (id) => {
  const response = await requestWithFallback((endpoint) =>
    axios.delete(`${endpoint}/remove`, {
      data: { id },
    })
  );
  return response.data;
};

export const removeAllPackageTimeBlocksByDateApi = async (date) => {
  const response = await requestWithFallback((endpoint) =>
    axios.delete(`${endpoint}/remove-all`, {
      data: { date },
    })
  );
  return response.data;
};
